import { UtilityProgram } from '@/types/utilityProgram'

const DEFAULT_FAQ_URL =
  'https://optiwatt.zendesk.com/hc/en-us/categories/35556339818267-Utility-Programs'

export function getProgramFaqUrl(
  utilityProgram: UtilityProgram | undefined,
): string {
  const cmsUrl =
    utilityProgram?.faq_url?.trim() ??
    utilityProgram?.view_config_json?.faqUrl?.trim()
  return cmsUrl || DEFAULT_FAQ_URL
}
